/**
 * تحديث تلقائي للواجهة بعد كل نشر (بواجهة المتصفح المباشرة — بلا مكتبات إضافية):
 *  • يسجّل sw.js ويفحص وجود نسخة جديدة عند الفتح، وكل 5 دقائق، وعند العودة للتبويب.
 *  • sw.js المُولَّد (registerType: autoUpdate) يتفعّل فوراً ويتحكّم بالصفحة ⇒ نعيد التحميل مرة واحدة.
 * بدونه كانت الصفحة المفتوحة تبقى على النسخة القديمة حتى تحديثها مرتين يدوياً.
 */
const CHECK_EVERY_MS = 5 * 60 * 1000;

export function setupAutoUpdate(): void {
  if (!('serviceWorker' in navigator) || import.meta.env.DEV) return;

  // أول زيارة (بلا متحكّم سابق) لا تحتاج إعادة تحميل — فقط عند استبدال نسخة قائمة
  const hadController = Boolean(navigator.serviceWorker.controller);
  let reloading = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!hadController || reloading) return;
    reloading = true;
    window.location.reload();
  });

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .then((registration) => {
        const check = (): void => {
          if (navigator.onLine) void registration.update().catch(() => undefined);
        };
        setInterval(check, CHECK_EVERY_MS);
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') check();
        });
      })
      .catch(() => undefined);
  });
}
